export class NotFoundException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 404;
  }
}

export class ServiceUnavailableException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 503;
  }
}

export class ParameterRequiredException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 400;
  }
}

export class OutOfDateException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 400;
  }
}

export class InvalidException extends Error {
  code: number;
  headers: Record<string, string> | undefined;
  constructor(message: string, headers?: Record<string, string>) {
    super(message);
    this.name = this.constructor.name;
    this.code = 400;
    this.headers = headers
  }
}

export class UnconfiguredException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 500;
  }
}

export class EmptyResponseException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 404;
  }
}

export class UnauthorizedException extends Error {
  code: number;
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
    this.code = 401;
  }
}
